import { motion } from 'framer-motion'
import { User } from '@phosphor-icons/react'
import { useNavigate } from 'react-router-dom'
import type { User as UserType } from '@/store/auth'

interface HeaderAvatarProps {
  user: UserType | null
}

export function HeaderAvatar({ user }: HeaderAvatarProps) {
  const navigate = useNavigate()

  return (
    <motion.button
      className="relative w-9 h-9 rounded-full overflow-hidden ring-2 ring-black/5 focus:outline-none focus-visible:ring-black focus-visible:ring-offset-2 flex-shrink-0"
      whileTap={{ scale: 0.95 }}
      onClick={() => navigate('/profile')}
      aria-label="View profile"
    >
      {user ? (
        <div className="w-full h-full bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center">
          <span className="text-white text-sm font-semibold">
            {user.name?.charAt(0).toUpperCase() || 'U'}
          </span>
        </div>
      ) : (
        <div className="w-full h-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
          <User size={18} className="text-gray-600" weight="bold" />
        </div>
      )}
    </motion.button>
  )
}
